import { GetMock } from './../../MockFile';
import { map, catchError } from 'rxjs/operators';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CampaignRequest } from '../../models/Campaign/CampaignRequest.model';
import { Observable } from 'rxjs';
import { CampaignResponse } from '../../models/Campaign/CampaignResponse.model';
import { AppStateService } from '../app-state/app-state.service';
import { CampaignState } from '../../models/Campaign/CampaignState.model';
import { OnLoadCampaignSuccess, OnLoadAlternativeCampaignSuccess, OnLoadAlternativeCampaignFailed, OnSelectAlternativeCampaignSuccess } from '../app-state/app-state.action';
import { OnLoadCampaignFailed } from '../app-state/app-state.action';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {
  private baseUrlController = 'Campaign';
  constructor(
    private appStateService: AppStateService,
    private http: HttpClient
  ) { }

  public LoadCampaign(req ?: CampaignRequest, isAlternative = false): Observable<CampaignResponse> {
    return this.http.post<CampaignResponse>(`${environment.baseApiUrl}/${this.baseUrlController}/LoadCampaign`, req).pipe(
      map(res => {
        const state: CampaignState = {
          request: req,
          response: res,
          ...req,
          ...res
        };
        if (!isAlternative) {
          if (res.IsSuccessful) {
            this.appStateService.updateState(new OnLoadCampaignSuccess(state));
          } else {
            if (environment.isMocked) {
              res = GetMock('LoadCampaign');
              this.appStateService.updateState(new OnLoadCampaignSuccess(res));
            } else {
              this.appStateService.updateState(new OnLoadCampaignFailed(state));
            }
          }
        }
        if (isAlternative) {
          if (res.IsSuccessful) {
            this.appStateService.updateState(new OnLoadAlternativeCampaignSuccess(state));
          } else {
            if (environment.isMocked) {
              res = GetMock('LoadCampaignAlternative');
             // this.appStateService.updateState(new OnLoadAlternativeCampaignSuccess(res));
            } else {
              this.appStateService.updateState(new OnLoadAlternativeCampaignFailed(state));
            }
          }
        }
        return res;
      }, catchError)
    );
  }

  public SelectAlternativeCampaign(): Observable<CampaignResponse>  {
    // Todo - fix Method to post API
    return new Observable((observer) => {
      const state: CampaignState = this.appStateService.currentState.AlternativeCampaign;
      this.appStateService.updateState(new OnSelectAlternativeCampaignSuccess(state));
      observer.next(state.response);
      observer.complete();
    });
  }
}
